export default {
  buildUpdate(id, name, phoneNumber, avatar, email, comments) {
    return {
      'data': {
        'attributes': {
          'name': name,
          'phone-number': phoneNumber,
          'avatar': avatar,
          'email': email,
          'comments': comments,
        },
        'type': 'customers',
        'id': id,
      },
    };
  },
  buildCreate(name, phoneNumber, avatar, email, comments) {
    return {
      'data': {
        'attributes': {
          'name': name,
          'phone-number': phoneNumber,
          'avatar': avatar,
          'email': email,
          'comments': comments,
        },
        'type': 'customers',
      },
    };
  },
  async updateCustomer(customerId, data, axios, token) {
    return await axios.patch(`/api/message/customers/${customerId}/`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  },
  async createCustomer(data, axios, token) {
    return await axios.post('/api/message/customers/', data, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  },
  async getCustomers(axios, token) {
    return await axios.get('/api/message/customers/', {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  }
};
